import { NoPIIType } from "utils/NoPII";
import {
  ActionType,
  AnalyticsSurface,
  ExtraMetadata,
} from "utils/analytics/analyticsConstants";
import { featureEnabled } from "utils/env";
import { OnboardingState } from "utils/analytics/analyticsConstants";
import { analyticsId } from "utils/analytics";

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Appcues: any;
  }
}
const enableAppcues = featureEnabled("ENABLE_APPCUES");
export function trackAppcuesPageTransition() {
  enableAppcues && window.Appcues?.page();
}

// This function is called once after auth but before the viewer query
// executes. That's why some of its parameters are optional
export function identifyUserForAppcues(
  userId: string,
  userType: string,
  schoolId?: string,
  onboardingState?: OnboardingState,
) {
  const analyticsUserId = analyticsId(userId);
  if (enableAppcues && window.Appcues) {
    const data = Object.assign(
      {},
      userType,
      onboardingState ? { userOnboardingState: onboardingState } : null,
      schoolId ? { schoolId } : null,
    );
    window.Appcues.identify(analyticsUserId, data);
  }
}

export function trackEventForAppcues(
  eventName: NoPIIType,
  event: {
    eventType: ActionType;
    analyticsSurface: AnalyticsSurface;
    extraMetadata?: ExtraMetadata;
  },
) {
  // Appcues only takes attributes as a flat object (not nested)
  const deconstructedEvent = {
    eventType: event.eventType,
    analyticsSurface: event.analyticsSurface,
    ...event.extraMetadata,
  };
  enableAppcues &&
    eventName &&
    window.Appcues?.track(eventName, deconstructedEvent);
}
